import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { CrsSearchModule } from '../crs-search/crs-search.module';
import { CreateJobSiteContentComponent } from './create-job-site-content/create-job-site-content.component';
import { CreateJobSiteDialogComponent } from './create-job-site-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        CrsSearchModule,
        DirectivesModule,
    ],
    exports: [CreateJobSiteDialogComponent],
    declarations: [CreateJobSiteDialogComponent, CreateJobSiteContentComponent],
    providers: [],
})
export class CreateSiteDialogModule {}
